module.exports = __webpack_public_path__ + "img/gvt.1bdab0fe.svg";